<template>
  <check-base-layout :show-mark="false" :check-info-data="checkFrom" :pagetitle="pagetitle">
    <template>
      <check-module :title="`合同总览`">
        <compart-module :compart-data="orderContractBase"></compart-module>
      </check-module>
      <div>
        <customer-module :customer-data="checkFrom.customerAccountCreditVo"></customer-module>
      </div>
      <check-module :title="`物流信息`" v-if="orderLogistic">
        <div v-if="orderLogistic.logicType === '快递配送'">
          <el-row>
            <el-col :span="8">
              <div class>物流方式：{{orderLogistic.logicType}}</div>
            </el-col>
            <el-col :span="8">
              <div class>快递公司：{{orderLogistic.logicCompany}}</div>
            </el-col>
            <el-col :span="8">
              <div class>物流费用：{{orderLogistic.logicFeetype}}</div>
            </el-col>
          </el-row>
        </div>
        <div v-if="orderLogistic.logicType === '物流配送'">
          <el-row>
            <el-col :span="8">
              <div class>物流方式：{{orderLogistic.logicType}}</div>
            </el-col>
            <el-col :span="8">
              <div class>快递公司：{{orderLogistic.logicCompany}}</div>
            </el-col>
            <el-col :span="8">
              <div class>物流费用：{{orderLogistic.logicFeetype}}</div>
            </el-col>
          </el-row>
        </div>
        <div v-if="orderLogistic.logicType === '客户自提'">
          <el-row>
            <el-col :span="8">
              <div class>物流方式：{{orderLogistic.logicType}}</div>
            </el-col>
            <el-col :span="8">
              <div class>提货人：{{orderLogistic.logicCompany}}</div>
            </el-col>
          </el-row>
        </div>
        <div v-if="orderLogistic.logicType === '仓库配送'">
          <el-row>
            <el-col :span="8">
              <div class>物流方式：{{orderLogistic.logicType}}</div>
            </el-col>
          </el-row>
        </div>
      </check-module>
      <check-module :title="`账期设置`" :is-table="true">
        <div v-if="paymentdays">
          <el-row style="padding-left: 20px;" :gutter="20">
            <el-col :span="8">
              <div class="pb20">合同金额：{{paymentdays.contractTotal | toFixed}}</div>
            </el-col>
            <el-col :span="8">
              <div class="pb20">付款类型：{{payTypeStatus[paymentdays.payType]}}</div>
            </el-col>
            <el-col :span="8" v-if="paymentdays.payType === 1">
              <div class="pb20">
                约定条件：{{paymentdays.orderContractBasePayVoList[0] &&
                paymentdays.orderContractBasePayVoList[0].date}}
              </div>
            </el-col>
          <!-- </el-row>
          <el-row style="padding-left: 20px;"> -->
            <el-col :span="8"  class="pb20">
              <div v-if="!paymentdays.replenMark">补充说明：{{ '--' }}</div>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                :content="paymentdays.replenMark"
                placement="top"
              >
                <span class="ellipsis-text">补充说明：{{paymentdays.replenMark }}</span>
              </el-tooltip>
            </el-col>
            <el-col :span="8">
              <div class="pb20" style='text-align:left;'>交货设置：{{deliverySettingStatus[paymentdays.deliverySetting]}}</div>
            </el-col>
            <el-col :span="8" v-if="paymentdays.deliverySetting === 2">
              <div class="pb20">整单约定发货日期：{{paymentdays.deliveryDate | dateFilterD}}</div>
            </el-col>
          </el-row>
          <el-table
            :data="tableDataex"
            :span-method="arraySpanMethod"
            :header-cell-style="tableHeader"
            border
            v-if="paymentdays.payType !== 1"
            style="width: 100%"
          >
            <el-table-column prop="aaState" label="付款项">
              <template v-slot="{ row }">
                <div :style="{'text-align':row.isbing ? 'center':'left'}">{{row.payment}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="金额">
              <template v-slot="{ row }">
                <div>{{row.amount | priceFilterNum}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="point" label="比例">
              <template v-slot="{ row }">
                <div v-if="!row.isbing">{{row.point | toPercentFormat}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </check-module>
      <check-module :title="`产品清单`" :is-table="true">
        <info-table
          :field-arr="proTableField"
          :table-data="tableData"
          v-if="paymentdays.payType !== 4"
          :table-height="`300px`"
        ></info-table>
        <div v-else style="margin-top: -20px;">
          <div v-for="(item,index) in bTableData" :key="index">
            <div>
              <el-row>
                <el-col :span="12">
                  <div style="padding:30px 0 14px;font-size:14px;font-weight: 500;">
                    <el-row>
                      <el-col :span="8">{{item.shipName}}：{{item.shipPrice | toFixed}}</el-col>
                      <el-col :span="8">本期货款：{{item.shipTotal | toFixed}}</el-col>
                      <el-col :span="8">预计付款时间：{{item.shipPayDate}}</el-col>
                    </el-row>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div
                    style="text-align: right;padding:30px 0 14px;"
                    v-show="item.shipTotal < item.shipPrice"
                  >
                    <i
                      class="el-icon-warning-outline"
                      style="color:#D35E5E;font-size: 16px;vertical-align: -1px"
                    ></i>
                    <span style="color:#D35E5E">本期货款＜本期产品报价总额</span>
                  </div>
                </el-col>
              </el-row>
              <info-table
                :field-arr="proTableField"
                :table-data="item.orderShipmentQueryVoList"
                :table-height="`auto`"
              ></info-table>
            </div>
          </div>
        </div>
        <div class="allfield_title">总计</div>
        <info-table
          :field-arr="allFieldArr"
          :table-data="allTableData"
          :to-fixed-format="['contractTotal','contractCost']"
          :table-height="allTableData.length ? `73px` : 'auto'"
        ></info-table>
      </check-module>
    </template>
    <template v-slot:checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module :check-data="checkFrom.systemFlowRunAuditOrgVos"></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>
<script>
import poMixins from '@/mixin/poMixins'
import sellpactApi from '@/api/workbench/check'
import { deepClone } from '@/util'
import { payTypeStatus, deliverySettingStatus, cbPriceSourceStatus } from '@/meun/date'

export default {
  name: 'makeofferCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '销售合同审批'
    }
  },
  created() {
    const { snaId } = this
    sellpactApi
      .sellpactCheckInfo({
        snaId
      })
      .then(res => {
        this.checkFrom = deepClone(res.data.obj)
        this.$emit('update:data', deepClone(res.data.obj))
      })
  },
  computed: {
    orderContractBase() {
      const { checkFrom } = this
      const { customerAccountCreditVo } = checkFrom
      return Object.assign(checkFrom.orderContractBase, {
        ownName: checkFrom.ownName,
        cusName: customerAccountCreditVo && customerAccountCreditVo.cusName
      })
    },
    // 物流信息
    orderLogistic() {
      return this.checkFrom.orderContractLogistic
    },
    // 产品清单
    tableData() {
      // const { payType } = this.historyListData
      // if (payType === 4) {
      //   return this.historyListData.orderShipmentContentVoList
      // }
      return this.checkFrom.orderContractContentIdVoList || []
    },
    // 账期设置
    paymentdays() {
      return this.checkFrom.orderContractBaseDeliverySettingVo || {}
    },
    // 总计
    allTableData() {
      return this.checkFrom.orderContractBase ? [this.checkFrom.orderContractBase] : []
    },
    bTableData() {
      return this.checkFrom.orderShipmentContentVoList || []
    },
    tableDataex() {
      const { checkFrom } = this
      const ax =
        (checkFrom.orderContractBaseDeliverySettingVo &&
          checkFrom.orderContractBaseDeliverySettingVo.orderContractBasePayVoList) ||
        []
      const ex = []
      let zb = null
      if (ax.length !== 0) {
        ax.forEach(item => {
          if (item.payment !== '质保期限') {
            ex.push(item)
          } else {
            zb = item
          }
        })
        if (zb) {
          ex.push({
            isbing: true,
            payment: `质保期限：${zb.payAmount}`
          })
        }
        return ex
      }
      return ax
    }
  },
  data() {
    return {
      checkFrom: {
        orderContractContentVo: {},
        orderContractBase: {}
      },
      payTypeStatus,
      deliverySettingStatus,
      allFieldArr: [
        {
          name: 'contractKind',
          label: '产品种类'
        },
        {
          name: 'contractTotal',
          label: '报价总额'
        },
        {
          name: 'contractCost',
          label: '供货成本'
        },
        {
          name: 'contractRate',
          label: '毛利率'
        }
      ],
      proTableField: [
        {
          name: 'brandName',
          label: '品牌'
        },
        {
          name: 'seriesName',
          label: '系列'
        },
        {
          name: 'proName',
          label: '产品名称'
        },
        {
          name: 'proType',
          label: '型号'
        },
        {
          name: 'orderNumber',
          label: '订货号'
        },
        {
          name: 'cbUnit',
          label: '单位'
        },
        {
          name: 'cbNumber',
          label: '数量'
        },
        {
          name: 'cbExtimeValue',
          label: '货期',
          formatter(val) {
            if (!val) return '--'
            // const d = val.split('-')
            // if (d.length !== 2) return val
            return val + '天'
          }
        },
        {
          name: 'cbRemind',
          label: '提醒'
        },
        {
          name: 'cbPrice',
          label: '单品报价'
        },
        {
          name: 'cbDiscount',
          label: '折扣'
        },
        {
          name: 'cbRate',
          label: '毛利率'
        },
        {
          name: 'cbTotal',
          label: '总报价'
        },
        {
          name: 'cbUnitPrice',
          label: '供货单价'
        },
        {
          name: 'cbUnitTotal',
          label: '供货总价'
        },
        {
          name: 'mark',
          label: '备注'
        },
        {
          name: 'cbFacePrice',
          label: '面价'
        },
        {
          name: 'cbPriceSource',
          label: '询价来源',
          formatter: data => {
            return cbPriceSourceStatus[data]
          }
        }
      ]
    }
  },
  methods: {
    arraySpanMethod({ row }) {
      if (row.isbing) return [1, 3]
      return [1, 1]
    }
  }
}
</script>

<style scoped>
</style>
